module.exports = __webpack_public_path__ + "img/signup-guide-04-01.40c07fc6.png";